import type { ArtbrushReferenceImage } from "../../utils/artbrushReference";

export function ArtbrushReferenceLayer({
    reference,
    opacity,
}: {
    reference: ArtbrushReferenceImage;
    opacity: number;
}) {
    const o = Math.max(0, Math.min(1, opacity));
    return (
        <image
            href={reference.dataUrl}
            x={reference.x}
            y={reference.y}
            width={reference.width}
            height={reference.height}
            opacity={o}
            preserveAspectRatio="none"
            className="artbrush-svg-canvas__reference"
        />
    );
}
